import { useTranslations } from '@vocab/react';
import { Heading } from 'braid-design-system';

import translations from './.vocab/index.ts';

/**
 * These sections are easier to test and should contain most of the tests for business/stateful logic
 */
export const HeaderSection = () => {
  const { t } = useTranslations(translations);

  return <Heading level="2">{t('pay-post-page-heading')}</Heading>;
};
